//Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//Modules
import { AuthRoutingModule } from './auth.routing';
import { MaterialModule } from 'src/app/shared/libraries/angular-material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
//Components
import { MainAuthComponent } from './pages/main-auth/main-auth.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { Step2Component } from './pages/step2/step2.component';
import { ComponentsAuthModule } from './components/components-auth.module';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Step1Component } from './pages/step1/step1.component';
import { MainSignUpComponent } from './pages/main-sign-up/main-sign-up.component';
import { NewLoginComponent } from './pages/new-login/new-login.component';

@NgModule({
	declarations: [
		ForgotPasswordComponent,
		MainAuthComponent,
		SignUpComponent,
		Step2Component,
		Step1Component,
		MainSignUpComponent,
		NewLoginComponent,
	],
	imports: [
		AuthRoutingModule,
		ComponentsAuthModule,
		CommonModule,
		MaterialModule,
		ReactiveFormsModule,
		FormsModule,
		RouterModule,
		//Translate
		SharedModule,
		TranslateModule,
	],
})
export class AuthModule {}
